import { render } from "./EmpFilesPage.vue?vue&type=template&id=45aa27d1&scoped=true"
import script from "./EmpFilesPage.vue?vue&type=script&lang=js"
export * from "./EmpFilesPage.vue?vue&type=script&lang=js"

import "./EmpFilesPage.vue?vue&type=style&index=0&id=45aa27d1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45aa27d1"]])

export default __exports__